module.exports = __webpack_public_path__ + "static/img/pliceIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/pliceIcon.png
// module id = diev
// module chunks = 9